<template>
    <div>
        <div class="cover" :style="{ backgroundImage: 'url('+img_api +pageData.bannerImg + ')' }">
            <div class="front">
                <div class="title">
                    <div class="big_title">
                        {{ pageData.firstTitle }}
                    </div>
                    <div class="transparent_title">
                        {{ pageData.secondTitle }}
                    </div>
                </div>
                <div class="des">
                    {{ pageData.des }}
                </div>
            </div>
        </div>
        <!-- 面包屑 -->
        <div class="bread_box">
            <div class="crumb"><span class="your_position">您所在的位置:</span>
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                    <el-breadcrumb-item>{{ pageData.firstTitle }}{{
                        pageData.secondTitle }}</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
        </div>
    </div>
</template>

<script>
import api from '../config'
export default {
    name: '',
    data() {
        return {
            img_api:""
        }
    },
    props: ['pageData',],
    mounted() {
        this.img_api = api.img_api
    },

};
</script>

<style scoped>
.cover {
    overflow: hidden;
    height: 355px;
    /* background-image: url(../assets/img/ppjj2.png); */
    /* background-size: cover; */
    background-repeat: no-repeat;
    background-size:100% 100%;
    /* object-fit: fill; */
}

.front {
    margin-top: 72px;
    margin-left: 240px;
}

.title {
    display: flex;
}

.big_title {
    font-size: 68px;
    font-weight: bold;
    color: #FFFFFF;
}

.transparent_title {
    font-size: 68px;
    font-weight: bold;
    color: rgba(255, 255, 255, 0);
    color: rgba(255, 255, 255, 0);
    -webkit-text-stroke: 1px #FFFFFF;
    text-stroke: 1px #FFFFFF;
}

.des {
    font-size: 24px;
    color: #FFFFFF;
}

.bread_box {
    overflow: hidden;
    height: 60px;
    background-color: #F7F8FA;
}

.crumb {
    display: flex;
    margin-top: 23px;
    margin-left: 140px;
}

.your_position {
    line-height: 1;
    font-size: 14px;
    font-weight: 400;
    color: #13489D;
    margin-right: 5px;
}
</style>
